export default "__VITE_ASSET__BpMMjBt7__"